import React, { useState } from 'react';
import { TextField, Tooltip, CardHeader } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    DataGrid,
    PrimaryButton,
    CommonModal,
    PageTitleWithToolTip,
} from '../Common';
import { text_commonCellProps } from '../Common/DataGrid/utils';
import Routes from '../../routes';
import useViewport from '../../hooks/useViewport';
import { Grey2 } from '../../color_utils';
import toast from 'react-hot-toast';

export const Alias = ({
    id,
}) => {
    const [showAddAlias, setShowAddAlias] = useState(false);
    const [showDeleteAlias, setShowDeleteAlias] = useState(false);
    // US 16739: reactive so the mobile exclusion updates on resize/orientation.
    const { isMobile } = useViewport();
    const [clickedId, setClickedId] = useState(null);
    const [refreshgrid, setRefreshgrid] = useState(true);

    const closeAddAlias = () => setShowAddAlias(false);

    const closeDeleteAlias = () => setShowDeleteAlias(false);

    const saveAddAlias = () => {
        setShowAddAlias(false);
        setRefreshgrid(!refreshgrid);
    };

    const deleteClicked = (aliasId) => {
        setClickedId(aliasId);
        setShowDeleteAlias(true);
    };

    const saveDeleteAlias = () => {
        setShowDeleteAlias(false);
        setRefreshgrid(!refreshgrid);
    };

    const columns = [
        { field: 'name', headerName: 'Name', ...text_commonCellProps },
    ];
    // US 16739: Delete Alias lives in a Quick-Actions column, excluded on the
    // mobile breakpoint (view-only there).
    const actionRow = {
        type: 'actions',
        field: 'Quick Actions',
        width: 100,
        getActions: ({ row }) => ([
            <GridActionsCellItem
                key="delete"
                label="Delete Alias"
                icon={<Tooltip title="Delete Alias"><DeleteIcon sx={{ color: Grey2 }} /></Tooltip>}
                onClick={() => deleteClicked(row.id)}
            />,
        ]),
    };

    return (
        <>
            <DataGrid
                hideExportButton
                url={Routes.Location.LocationAliasTable(id)}
                refresh={refreshgrid}
                noResultText="Oops...It is empty here..."
                noResultText2="Please add an Alias to get started."
                columns={isMobile ? columns : [...columns, actionRow]}
                headerContent={
                    <CardHeader
                        title={<PageTitleWithToolTip pageTitle="Aliases" />}
                        sx={{
                            "& .MuiCardHeader-action": { display: "flex" },
                            "& .MuiCardHeader-content": { maxWidth: "100%", textWrap: "nowrap" }
                        }}
                    />
                }
            />

            <CommonModal open={showAddAlias} close={closeAddAlias}>
                <AddAlias id={id} saveCallback={saveAddAlias} />
            </CommonModal>

            <CommonModal open={showDeleteAlias} close={closeDeleteAlias}>
                <DeleteAlias id={clickedId} closeCallback={closeDeleteAlias} saveCallback={saveDeleteAlias} />
            </CommonModal>
        </>
    );
};

export function AddAlias(props) {
    const [newAlias, setNewAlias] = useState("");
    const [newAliasError, setnewAliasError] = useState(null);

    async function AddAlias(e) {

        if (newAlias == "") {
            setnewAliasError("This field is required");
            return;
        } else {
            setnewAliasError(null);
        }

        const response = await fetch(Routes.Location.AddAlias(props.id), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name: newAlias })
        })

        if (response.status === 200) {

            const newdata = await response.json();

            props.saveCallback();

        } else {
            toast.error('There was an error adding the new alias', { duration: 6000 });
        }

        setNewAlias("");
    }
    
    return (

        <div>
            <h1>Add Location Alias</h1>
            <div className="row mb-5">
                <div className="col-12">
                    <TextField
                        className=""
                        autoFocus
                        value={newAlias}
                        fullWidth
                        onChange={e => setNewAlias(e.target.value)}
                        label="Alias Name *"
                        error={newAliasError}
                        helperText={newAliasError}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <PrimaryButton
                        buttonText='Save'
                        onClick={AddAlias}
                    />
                    {/* <Button size="lg" className="popup-button" type="submit" onClick={AddAlias}>
                        Save
                    </Button> */}
                </div>
            </div>

        </div>


    );
};

export function DeleteAlias(props) {
    
    async function DeleteAlias(e) {

        const response = await fetch(Routes.Location.DeleteAlias(props.id), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })

        if (response.status === 200) {

            props.saveCallback();

        } else {
            toast.error('There was an error deleting the alias', { duration: 6000 });
        }

    }
    function CancelClick(e) {
        props.closeCallback();
    }

    return (

        <div>
            <h1>Delete Location Alias</h1>
            <h2>
                Are you sure you want to delete?
            </h2>

            <div className="row">
                <div className="col-12">
                    <PrimaryButton
                        buttonText='Cancel'
                        onClick={CancelClick}
                    />
                    <PrimaryButton
                        buttonText='Delete'
                        onClick={DeleteAlias}
                    />
                   {/*  <Button size="lg" className="popup-button mr-2" type="submit" onClick={CancelClick}>
                        Cancel
                    </Button >
                    <Button size="lg" className="popup-button" type="submit" onClick={DeleteAlias}>
                        Delete
                    </Button> */}
                </div>
            </div>

        </div>


    );
};
